import { takeEvery, put, call } from "redux-saga/effects";
import { types } from "../reducers/documents";
import { DocumentsService } from "../../services";
import { formatErrors } from "../../helpers/ErrorFormater";
import { MessageTypes } from "../../helpers/Messages";
import i18next from "i18next";
import LinkedSubjects from "../../services/LinkedSubjects";
import { sortForm } from "../../helpers/form";

export default function* () {
  yield takeEvery(
    types.DOCUMENTS_SUBMIT_REQUEST,
    submit,
  );
  yield takeEvery(
    types.DOCUMENTS_REQUEST,
    get,
  );
  yield takeEvery(
    types.DOCUMENTS_DATA,
    getData,
  );
  yield takeEvery(
    types.DOCUMENT_PUBLISH,
    publish,
  );
  yield takeEvery(
    types.DOCUMENT_REMOVE,
    remove,
  );
}

function* get({ value }) {
  const { namespace, module, view, status } = value || {};
  try {
    const { data } = yield call(() => DocumentsService.get(value));
    yield put({
      type: types.DOCUMENTS_SUCCESS,
      value: { documents: data.data, documentsOptions: data.options, totalItems: data.totalItems }
    });
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.DOCUMENTS_FAILED,
      value: formattedErrors,
    });
  }
}

function* getData({ value }) {
  if (['tazama'].includes(value.module)) {
    try {
      const { data: form } = yield call(() => LinkedSubjects.getForm({
        module: value.module,
        namespace: 'documents',
        scope: 'documents',
      }));

      let data = {};

      if (value.datastakeId) {
        const { data: _data } = yield call(() => LinkedSubjects.getOne({
          id: value.datastakeId,
          module: value.module,
          namespace: 'documents',
        }));

        data = _data;
      }

      if (form) {
        const _form = sortForm({ form });

        yield put({
          type: types.DOCUMENTS_SUCCESS,
          value: {
            [`${value.module}-${value.view}`]: {
              data,
              form: _form,
            },
          },
        });
      }
    } catch (e) {
      console.log(e);
      const formattedErrors = formatErrors(e)
      yield put({
        type: types.DOCUMENTS_FAILED,
        value: formattedErrors,
      });
    }
    return;
  }

  try {
    const { data } = yield call(() => DocumentsService.getData(value));

    if (data) {
      yield put({
        type: types.DOCUMENTS_SUCCESS,
        value: {
          [`${value.module}-${value.view}`]: data,
        },
      });
    }
  } catch (e) {
    console.log(e);
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.DOCUMENTS_FAILED,
      value: formattedErrors,
    });
  }
}

function* submit({ value, callback }) {
  const { module, view, ...forms } = value || {};
  try {
    const {
      data,
    } = yield call(() => DocumentsService.submit({ ...forms, module, view }));
    if (data) {
      yield put({
        type: types.DOCUMENTS_SUBMIT_SUCCESS,
        value: { ...data, module, view }
      });

      callback(
        MessageTypes.SUCCESS,
        i18next.t('Information submitted successfully'),
        data
      );
    } else {
      callback(
        MessageTypes.WARNING,
        i18next.t('errors::Something wrong happend during saving data')
      );
    }
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.DOCUMENTS_SUBMIT_FAILED,
      value: formattedErrors,
    });
    if (Object.keys(formattedErrors).length > 0) {
      callback(
        MessageTypes.WARNING,
        i18next.t('errors::Please fill all required fields')
      );
    } else {
      callback(
        MessageTypes.WARNING,
        i18next.t('errors::Something wrong happend during saving data')
      );
    }
  }
}

function* publish({ value: { id, module, view }, callback }) {
  try {
    if (typeof id === 'string') {
      const { data } = yield call(() => DocumentsService.publish(id));
      if (data) {
        yield put({ type: types.DOCUMENT_PUBLISH_SUCCESS, value: { ...data, module, view } });
        callback(MessageTypes.SUCCESS, i18next.t('Information submitted successfully'));
      } else {
        callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
      }
    }
  } catch (e) {
    const formattedErrors = formatErrors(e);
    yield put({
      type: types.DOCUMENT_PUBLISH_FAILED,
      value: formattedErrors,
    });
    if (Object.keys(formattedErrors).length > 0) {
      callback(MessageTypes.WARNING, i18next.t('errors::Please fill all required fields'))
    } else {
      callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
    }
  }
}

function* remove({ value, callback }) {
  try {
    const { data } = yield call(() => DocumentsService.remove(value.id, value.data));
    if (data) {
      yield put({ type: types.DOCUMENT_REMOVE_SUCCESS, value: data });
      callback(MessageTypes.SUCCESS, i18next.t('Document deleted'));
    }
  } catch (e) {
    const formattedErrors = formatErrors(e);
    yield put({
      type: types.DOCUMENT_REMOVE_FAILED,
      value: formattedErrors,
    });
  }
}
